import { useState } from "react";
import "./Accordion.css";

const Accordion = ({ title, icon, children, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`accordion ${open ? "open" : ""}`}>
      <div className="accordion-header" onClick={() => setOpen(!open)}>
        <div className="accordion-title">
          <span className="icon">{icon}</span>
          {title}
        </div>
        <span className="chevron">{open ? "▲" : "▼"}</span>
      </div>

      <div className="accordion-content">
        {children}
      </div>
    </div>
  );
};

export default Accordion;
